import { usePageType } from "@/hooks/usePageType";
import Link from "next/link";
import { trackClickAds } from "../util/functions";

const TwoColumnsAds = ({ ads }: { ads: any[] }) => {
	const pageType = usePageType();
	return (
		<div className="flex flex-wrap justify-around gap-5">
			{ads.map((ad) => (
				<Link
					key={ad.id}
					className="lg:max-w-[622px] max-w-[300px] block relative"
					href={ad.link}
					onClick={() => trackClickAds(ad.id, pageType)}
					target="_blank"
					rel="nofollow noopener"
				>
					<img
						src={process.env.NEXT_PUBLIC_FILE_URL + ad?.file?.code}
						alt={ad?.title}
					/>
				</Link>
			))}
		</div>
	);
};

export default TwoColumnsAds;
